import React from "react";

import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";

interface SidebarHeaderProps {
  collapsed?: boolean;
  onToggle?: () => void;
}

const HEADER_HEIGHT = 56;

const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  collapsed = false,
  onToggle,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: collapsed ? "center" : "flex-end",
        height: HEADER_HEIGHT,
        px: collapsed ? 0 : "12px",
        py: 0,
        borderBottom: `1px solid ${theme.palette.divider}`,
        transition: theme.transitions.create(["padding", "justify-content"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.standard,
        }),
      }}
    >
      {!collapsed && onToggle && (
        <Tooltip title="Collapse sidebar">
          <IconButton
            onClick={onToggle}
            size="small"
            aria-label="Collapse sidebar"
            sx={{
              color: "text.secondary",
              "&:hover": {
                color: "primary.main",
                bgcolor: theme.palette.action.hover,
              },
            }}
          >
            <MenuOpenIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default SidebarHeader;
